"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

var _get_cat_tags = require("@/api/get_cat_tags");

var _cat_tags = require("@/api/cat_tags");

var _big_cat_tags_sort = require("@/api/big_cat_tags_sort");

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      editCatTagsForm: {
        tags: null
      },
      catTagsIdList: [],
      inputVisible: false,
      inputValue: '',
      activeName: 'first'
    };
  },
  components: {
    vuedraggable: _vuedraggable.default
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.listLoading = true;
      (0, _get_cat_tags.getCatTags)().then(function (response) {
        var catTagsList = response.data;
        var _tagList = []; // this.editCatTagsForm.tags = catTagsList

        (0, _big_cat_tags_sort.getBigCatTagsSortList)().then(function (CatTagsSortList) {
          // 第一次排序，数据库中排序记录为空，所以直接按照默认排序展示
          if (!CatTagsSortList.data) {
            _this.editCatTagsForm.tags = catTagsList;
            _this.listLoading = false;
            return;
          } else {
            var sortList = CatTagsSortList.data.list;
            sortList.split(',').forEach(function (id) {
              catTagsList.forEach(function (tag, tagI) {
                if (tag.id == id) {
                  _tagList.push(tag);

                  catTagsList.splice(tagI, 1);
                }
              });
            });

            if (catTagsList.length > 0) {
              _this.editCatTagsForm.tags = _tagList.concat(catTagsList);
            } else {
              _this.editCatTagsForm.tags = _tagList;
            }
          }

          _this.listLoading = false;
        });
      });
    },
    // 拖拽动作完成后，获取最新列表并保存
    end: function end() {
      var _this2 = this;

      var $ = this;
      $.catTagsIdList = [];
      $.editCatTagsForm.tags.forEach(function (tag, catI) {
        $.catTagsIdList.push(tag.id);
      });
      $.$store.dispatch('big_cat_tags_sort/edit', {
        big_cat_tags_sort_list: $.catTagsIdList
      }).then(function (data) {
        console.log(data);

        _this2.$message({
          message: data.msg,
          type: 'success'
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    handleClose: function handleClose(tag) {
      var _this3 = this;

      (0, _cat_tags.destroy)(tag.id).then(function (data) {
        _this3.$message({
          message: data.msg,
          type: 'success'
        });

        _this3.editCatTagsForm.tags.splice(_this3.editCatTagsForm.tags.indexOf(tag), 1);

        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    showInput: function showInput() {
      var _this4 = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this4.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var _this5 = this;

      var inputValue = this.inputValue;

      if (inputValue) {
        this.$store.dispatch('cat_tags/edit', {
          tag: inputValue
        }).then(function (data) {
          console.log(data);

          _this5.$message({
            message: data.msg,
            type: 'success'
          });

          _this5.editCatTagsForm.tags.push(data.data);

          _this5.loading = false;
        }).catch(function () {
          _this5.loading = false;
        });
      }

      this.inputVisible = false;
      this.inputValue = '';
    },
    handleClick: function handleClick(tab, event) {// console.log(tab, event)
    }
  }
};
exports.default = _default;